export const TEAMS_ES = {
    
}